import React from 'react';
import { connect } from 'react-redux';
import InfoModal from '../../../components/Utils/InfoModal';
import { orgsCreateComment, orgsCreateReplyComment } from '../../../actions/OrgsComments';
import MentionTextarea from '../../Utils/MentionTeaxtarea';
import { getLabel } from '../../../language'
import defaultAvatar from '../../../images/avatar.svg';

const mapStateToProps = state => {
  return {
    currentUser: state.common.currentUser,
    user: state.user,
    isOpen: false,
  }
};

const mapDispatchToProps = dispatch => ({
  onSubmit: dispatch(orgsCreateComment),
  onReplyComment: dispatch(orgsCreateReplyComment),
});

class OrgsSmallCommentInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text: '',
      replyMyPostsAndComments: this.props.orgs && this.props.orgs.replyMyPostsAndComments || 3,
    };

    this.onSubmitComment = this.onSubmitComment.bind(this);
    this.changeInput = this.changeInput.bind(this);
    this.onReplyComment = this.onReplyComment.bind(this);
  }

  onSubmitComment(ev) {
    ev.preventDefault();
    this.props.onSubmit(this.props.orgs.id, this.state.text, parseInt(ev.target.value), parseInt(ev.target.value));
    this.props.addCommentClick();
    this.setState({
      text: '',
      replyMyPostsAndComments: parseInt(ev.target.value),
    })
  }

  onReplyComment(ev) {
    ev.preventDefault();
    this.props.onReplyComment(this.props.orgs.id, this.state.text, parseInt(ev.target.value), parseInt(ev.target.value));
    this.setState({
      text: '',
      replyMyPostsAndComments: parseInt(ev.target.value),
    })
  }

  changeInput(ev) {
    this.setState({ text: ev.target.value });
  }

  openModal = () => {
    this.setState({ isOpen: !this.state.isOpen })
  }

  render() {
    const { currentUser, user } = this.props;
    return (
      <div className="row">
        <InfoModal isOpen={this.state.isOpen} onClose={this.openModal} title={getLabel(62)} description={getLabel(58)} video={'https://www.youtube.com/embed/ji2f5WdYATA'} />
        <div className="col-md-1 col-1 col-xs-2 col-2">
          <a className="politician">
            <img src={user && user.avatar ? user.avatar : defaultAvatar}
              className="user-pic border-radius-10"
              alt='' />
            <span className={`${parseInt(currentUser && currentUser.gender) === 1 && "female "}${parseInt(currentUser && currentUser.gender) === 2 && "male"}`} />
          </a>
        </div>
        <div className="col-md-10 col-10 col-xs-9 col-9">
          <MentionTextarea className="form-control with-border"
            changeBody={this.changeInput}
            rows={2}
            value={this.state.text}
            disabled={this.props.isAvailableForReply === false}
            placeholder={getLabel(59)} />
        </div>
        <div className="col-md-1 col-1">
          <a className="btn btn-default btn-sm small margintop" title="help" onClick={this.openModal} >
            <i className="fa fa-question-circle pol" />
          </a>
        </div>
        <div className="col-md-12">
          <ul className="commentset text-right">
            <li><button className={`btn btn-sm btn-private replylink reply_private ${parseInt(this.state.replyMyPostsAndComments) === 1 && ''}`} value={1} title={getLabel(217)} onClick={this.props.replyComment ? this.onReplyComment : this.onSubmitComment}>{getLabel(60)}</button></li>
            {this.props.replyMyPostsAndComments !== 1 && <li><button className={`btn btn-sm btn-group  replylink reply_group ${parseInt(this.state.replyMyPostsAndComments) === 2 && ''}`} value={2} title={getLabel(218)} onClick={this.props.replyComment ? this.onReplyComment : this.onSubmitComment}>{getLabel(61)}</button></li>}
            {this.props.replyMyPostsAndComments !== 1 && <li><button className={`btn btn-sm btn-public  replylink reply_public ${parseInt(this.state.replyMyPostsAndComments) === 3 && ''}`} value={3} title={getLabel(219)} onClick={this.props.replyComment ? this.onReplyComment : this.onSubmitComment}>{getLabel(62)}</button></li>}
          </ul>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OrgsSmallCommentInput);
